//joinus hover animation
const list = document.querySelector(".s-projectsCategories__right__list");
const liElements = Array.prototype.slice.call(list.children);

liElements.forEach((el) => {
  el.addEventListener("mouseover", () => {
    el.children[0].children[0].children[0].classList.add("pink");
    el.children[1].classList.add("long--white");
  });
  el.addEventListener("mouseout", () => {
    el.children[0].children[0].children[0].classList.remove("pink");
    el.children[1].classList.remove("long--white");
  });
});
